import { render, staticRenderFns } from "./Warehousing.vue?vue&type=template&id=c35cb8ec&scoped=true&"
import script from "./Warehousing.vue?vue&type=script&lang=js&"
export * from "./Warehousing.vue?vue&type=script&lang=js&"
import style0 from "./Warehousing.vue?vue&type=style&index=0&id=c35cb8ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35cb8ec",
  null
  
)

export default component.exports